<template>
	<div class="avatar-edit">
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black"
						style=" height: 45px;margin-left: -50%; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('qianbao')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="preview">
			<img :src="currentAvatar" alt="头像预览" class="preview-img">
		</div>
		<div class="actions">
			<button @click="changeAvatar" class="btn">{{$t('xuaze')}}</button>
			<button @click="confirmAvatar" class="btn primary">{{$t('tjiao')}}</button>
		</div>
		<input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" style="display: none">
	</div>
</template>

<script>
	export default {
		name: 'Avatar',
		data() {
			return {
				currentAvatar: this.$route.query.currentAvatar || require('@/assets/image/a1.jpg'),
				newAvatar: null
			}
		},
		methods: {
			changego() {
				this.$router.go(-1);
			},
			changeAvatar() {
				this.$refs.fileInput.click()
			},
			handleFileChange(e) {
				const file = e.target.files[0]
				if (file) {
					const reader = new FileReader()
					reader.onload = (event) => {
						this.currentAvatar = event.target.result
						this.newAvatar = file
					}
					reader.readAsDataURL(file)
				}
			},
			confirmAvatar() {
				if (this.newAvatar) {
					// 保存头像到本地存储
					localStorage.setItem('userAvatar', this.currentAvatar)
					// 返回个人主页并传递新头像
					this.$router.push({
						path: '/personal',
						query: {
							newAvatar: this.currentAvatar
						}
					})
				} else {
					this.$router.push('/personal')
				}
			}
		}
	}
</script>
<style scoped>
	.avatar-edit {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
	}

	.preview {
		margin-bottom: 20px;
	}

	.preview-img {
		width: 200px;
		height: 200px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid #eee;
	}

	.actions {
		padding: 10px 20px;
		width: 100%;
	}

	.btn {
		width: 100%;
		margin-top: 15px;
		padding: 10px 20px;
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		text-align: center;
		text-decoration: none;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: transparent;
		overflow: hidden;
		color: #000;
		background-color: #f8f8f8;
		cursor: pointer;

	}

	.primary {
		background-color: #e64340;
		color: white;
	}
</style>